
import { mapActions, mapMutations } from 'vuex'
import { getLang, setPid, getAuth, setNewAuth, setStorage, getStorage } from '@/lib/storage'
import { isMobile } from '@/lib/device'
export default {
  computed: {
    lang () {
      return this.getLang()
    }
  },
  methods: {
    getLang,
    setPid,
    getAuth,
    setNewAuth,
    ...mapActions(['permissionMenu']),
    ...mapActions('organization/org', ['projectToLink']),
    ...mapActions('organization/orgRealback', ['chooseProject']),
    ...mapMutations(['setRoleDefault']),
    getOrgPro (orgList) {
      const keyArr = Object.keys(orgList)
      let name = 'OrgIndex'
      let query = {}

      if (keyArr.length === 1) {
        name = 'ProjectIndexPc'
        query['cid'] = keyArr[0]
        const org = Object.values(orgList)[0].projects
        const isInqury = org.xp
        const isMc = org.mc
        const isRealback = org.mc
        const mcProList = org[2] || []
        const inquryProList = org[1] || []
        const realbackProList = org[3] || []
        let projectData = {}
        let type = 'inquery'
        if (mcProList.length === 1 && inquryProList.length === 0 && realbackProList.length === 0) {
          projectData = org[2][0]
          type = 'member'
          if (projectData.status * 1 === 1) {
            this.toProject(projectData, type)
          } else {
            this.$router.push({
              name,
              query: {
                cid: projectData.cid,
                type: 'member'
              }
            })
          }
        } else if (mcProList.length === 0 && inquryProList.length === 1 && realbackProList.length === 0) {
          projectData = org[1][0]
          type = 'inquery'
          if (projectData.status * 1 === 1) {
            this.toProject(projectData, type)
          } else {
            this.$router.push({
              name,
              query: {
                cid: projectData.cid,
                type: 'inquery'
              }
            })
          }
        } else if (realbackProList.length === 1 && inquryProList.length === 0 && mcProList.length === 0) {
          projectData = org[3][0]
          type = 'realback'
          setStorage('realbackCid', (org && org.cid) || '')
          if (projectData.status * 1 === 1) {
            this.toProject(projectData, type)
          } else {
            this.$router.push({
              name,
              query: {
                cid: projectData.cid,
                type: 'realback'
              }
            })
          }
        } else {
          if (isInqury) {
            query['type'] = 'inquery'
          } else if (isMc) {
            query['type'] = 'member'
          } else if (isRealback) {
            query['type'] = 'realback'
          }
          // query['type'] = isMc && !isInqury ? 'member' : 'inquery'
          this.$router.push({
            name,
            query
          })
        }
      } else {
        name = 'OrgIndex'
        query = {}
        this.$router.push({
          name,
          query
        })
      }
    },
    async toProject (data, type) {
      if (data.status * 1 === 1) {
        const { cid, projectid } = data
        const isMember = type === 'member'
        if (type === 'member' || type === 'inquery') {
          let chain = await this.projectToLink()
          chain.params({ cid, projectid, pType: isMember ? 2 : 1 })
            .onSuccess(async (raw) => {
              const { Project: tid } = raw
              let to = ''
              let linkName = ''
              let routerName = 'InqueryList'
              switch (raw.type) {
                case 1: // 负责人, 观察员
                  linkName = { type: 'inquiry-manager-all', from: 'all' }
                  break
                case 2: // 开发
                  linkName = { type: 'inquiry-dev', from: 'my' }
                  break
                case 3: // 接待
                  linkName = { type: 'inquiry-add', from: 'my' }
                  break
                default: // 销售
                  linkName = { type: 'inquiry-followup', from: 'my' }
              }
              const pid = raw.Project // this.$store.state.pid
              // console.log(pid)
              //   console.log(this.getLang())
              //   this.setNewAuth(this.getAuth())
              if (isMember) {
                if (!isMobile) {
                  const $location = window.location
                  // const $query = '?auth=' + this.getAuth() + '&pid=' + projectid
                  if (process.env.NODE_ENV === 'development') {
                    location.href = '//' + $location.hostname + ':94/mc/project/' + pid + '/overview'
                  } else {
                    location.href = '//' + $location.host + '/mc/project/' + pid + '/overview'
                  }
                } else {
                  this.$router.push({
                    name: 'ProjectIndexPc',
                    query: {
                      cid
                    }
                  })
                }
              } else {
                this.setPid(tid)
                this.$store.commit('setPid', tid)
                if (raw.type === 0) {
                  if (isMobile) {
                    const toast = this.$createToast({
                      time: 2000,
                      txt: this.$t('message["1327"]') + '！',
                      type: 'txt'
                    })
                    toast.show()
                  } else {
                    this.setRoleDefault(true)
                    const chain = await this.permissionMenu() // 先请求菜单数据，判断自定义角色默认展示页
                    chain.onSuccess(res => {
                      for (let key in res) {
                        if (key === 'inquiry-mine' && res[key]['state']) {
                          let item = res[key]
                          if ('child' in item) {
                            for (let cKey in item['child']) {
                              linkName = { type: cKey, from: 'my' }
                              break
                            }
                          }
                          break
                        }
                        if (key === 'inquiry-mine' && !res[key]['state']) {
                        // console.log('查重： inquiry-check-repeat')
                          routerName = 'InqueryRepeat'
                          linkName = {}
                          break
                        }
                      }
                    }).onComplete(() => {
                    // console.log(linkName)
                      to = {
                        name: routerName,
                        params: {
                          pid
                        },
                        query: linkName
                      }
                      this.$router.push(to)
                    })
                  }
                } else {
                  to = {
                    name: routerName,
                    params: {
                      pid
                    },
                    query: linkName
                  }
                  this.$router.push(to)
                }
              }
            })
            .fetch()
        } else if (type === 'realback') {
          const realbackCid = getStorage('realbackCid')
          let chain = await this.chooseProject({
            cid2: cid,
            cid: realbackCid,
            projectid
          })
          chain
            .onSuccess(async (payload) => {
              const pid = payload.Project
              const $location = window.location
              if (process.env.NODE_ENV === 'development') {
                location.href = '//' + $location.hostname + ':94/wechatservices/project/' + pid + '/mp'
              } else {
                location.href = '//' + $location.host + '/wechatservices/project/' + pid + '/mp'
              }
            })
        }
      } else {
        // 登录后直接提示项目已关闭有问题，上面已判断，不走这里了
        if (!isMobile) {
          this.$warning({
            content: this.$t('message["1327"]') + '！'
          })
        } else {
          const toast = this.$createToast({
            time: 2000,
            txt: this.$t('message["1327"]') + '！',
            type: 'txt'
          })
          toast.show()
        }
      }
    },
    toolClick () {
      return false
    }
  }
}
